/**
 * `/:world/outside`: the works that belong to no sub-series. Not a reading
 * order, and it says so — these are read on their own, whenever.
 */

import { Link } from 'react-router'
import { worldPath } from '../../shared/routes.ts'
import { CataloguePage, usePageTitle } from '../components/Catalogue.tsx'
import { useI18n } from '../i18n/index.tsx'
import { mainTitle, outsideSeries, ungroupedLabel, type Loaded } from '../lib/catalogue.ts'

export function OutsideSeries() {
  return <CataloguePage>{(catalogue, world) => <OutsideView catalogue={catalogue} world={world} />}</CataloguePage>
}

function OutsideView({ catalogue, world }: { catalogue: Loaded; world: string }) {
  const { t, locale } = useI18n()
  const label = ungroupedLabel(catalogue.universe, locale)
  usePageTitle(label ?? t('series.not_found.title'))

  // The universe has no name for its ungrouped works: there is no such page.
  if (label === null) {
    return (
      <section className="panel">
        <h1>{t('series.not_found.title')}</h1>
        <p>{t('series.not_found.body')}</p>
      </section>
    )
  }

  return (
    <section className="panel">
      <h1>{label}</h1>
      <p>{t('outside.lead')}</p>
      <ul className="list-plain" aria-label={label}>
        {outsideSeries(catalogue).map((work) => (
          <li key={work.slug}>
            <Link to={worldPath(world, 'books', work.slug)}>{mainTitle(work, locale)}</Link>
            {work.year_first_published === null ? null : (
              <span className="year">{` (${String(work.year_first_published)})`}</span>
            )}
          </li>
        ))}
      </ul>
      <nav className="panel__links">
        <Link to={worldPath(world, 'series')}>{t('series.all')}</Link>
      </nav>
    </section>
  )
}
